import React, { useRef } from 'react'
// import { Link } from 'react-router-dom'
import Slider from 'react-slick'

const meetSlider = [
    {
        name: "Amulya Jain",
        batch: "2017",
        position: "Head, Tech & innovation ",
        profession: "Founder at Pentagons Digital",
        profile: "/assets/event/profile6.PNG",
        linkedinL: "https://www.linkedin.com/in/amulya-jain-2b8b1919b/"
    },
    {
        name: "Khushali Jaiswal",
        batch: "2017",
        position: "Head, membership & regional chapters",
        profession: "Senior Consultant, PwC",
        profile: "/assets/event/profile7.jpeg",
        linkedinL: "https://www.linkedin.com/in/khushalijaiswal/"
    },
    {
        name: "Raagini Bachhawat",
        batch: "2018",
        position: " Head, Branding and Communication",
        profession: "Founder at Peach Eye Studio.",
        profile: "/assets/event/profile8.jpeg",
        linkedinL: "https://www.linkedin.com/in/raagini-bachhawat?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
    },
    {
        name: "Shivangi Modi",
        batch: "2017",
        position: "Head, Mentorship & Career support ",
        profession: "Management Trainee, QI Lifecare",
        profile: "/assets/event/profile3.jpeg",
        linkedinL: "https://www.linkedin.com/in/shivangimodi1?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
    },
    {
        name: "Renika Garg",
        batch: "2017",
        position: "Head, Events & Engagement",
        profession: "Cybersecurity consultant at Marsh",
        profile: "/assets/event/profile4.jpeg",
        linkedinL: "https://www.linkedin.com/in/renika-garg/"
    },
    {
        name: "Mansa Bansal",
        batch: "2017",
        position: "Member of Events & Outreach and Regional Chapters",
        profession: "Architect and Founder at Elemental Arch Designs",
        profile: "/assets/event/profile5.jpeg",
        linkedinL: "https://www.linkedin.com/in/mansa-bansal-4a8533168/"
    },

    {
        name: "Diksha",
        batch: "2009",
        position: "Head, Delhi NCR Chapter",
        profession: "Founder at Pentagons Digital",
        profile: "/assets/event/img6.jpeg",
        linkedinL: "https://www.linkedin.com/in/amulya-jain-2b8b1919b/"
    },
]

function MeetSlider() {
    const sliderRef = useRef(null)

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 3000,
        pauseOnHover: true,
        arrows: false,
        responsive: [
            { breakpoint: 1550, settings: { slidesToShow: 3 } },
            { breakpoint: 1024, settings: { slidesToShow: 2 } },
            { breakpoint: 640, settings: { slidesToShow: 1 } },
        ],
    }

    return (
        <div className="relative">
            <div className="absolute lg:top-[-108px] top-auto lg:right-[40px] right-auto bottom-[-60px] lg:left-[unset] left-1/2 transform lg:translate-x-[unset] -translate-x-1/2 flex lg:space-x-8 space-x-3 z-10">
                <button
                    onClick={() => sliderRef.current.slickPrev()}
                    className="lg:h-[36px] h-[32px] lg:w-[36px] w-[32px] flex items-center justify-center"
                >
                    <img src="/assets/event/prev.svg" alt="prev" />
                </button>
                <button
                    onClick={() => sliderRef.current.slickNext()}
                    className="lg:h-[36px] h-[32px] lg:w-[36px] w-[32px] flex items-center justify-center"
                >
                    <img src="/assets/event/next.svg" alt="next" />
                </button>
            </div>

            <Slider ref={sliderRef} {...settings}>
                {meetSlider?.map((e, i) => {
                    return (
                        <div className='bg-[#C0E6EB] lg:h-[588px] h-[500px] max-w-[95%] w-full overflow-hidden relative pt-[32px] px-[42px] rounded-[10px]'>
                            <img src={e?.profile} className='w-full h-[400px] object-cover' alt="" />
                            <div className='max-w-[100%] py-[12px] w-full left-[50%] translate-x-[-50%] bg-[#FFFFFF] mx-auto absolute bottom-[24px]'>
                                <h6 className="font-[600] font-manrope text-[20px] leading-[32px] text-[#08717D] text-center">{e?.name}</h6>
                                {/* <h6 className="font-[600] font-manrope text-[13px] leading-[20px] text-[#d4af37] text-center">{e?.position}</h6> */}
                                <h6 className="font-[600] capitalize font-manrope text-[13px] leading-[20px] text-[#d4af37] text-center">{e?.position}</h6>
                                <p className="font-[400] font-manrope text-[16px] py-[6px] leading-[26px] text-[#696D82] text-center">{e?.profession}</p>
                                <div className="flex justify-center gap-[20px] items-center">
                                    <p className="capitalize text-[14px] leading-[20px] text-[#1F2544] font-[500] font-manrope">
                                        Batch of {e?.batch}
                                    </p>
                                    <a href={e?.linkedinL} target="_blank" rel="noopener noreferrer">
                                        <div className="flex items-center gap-[10px]">
                                            <svg
                                                className="w-4 h-4 text-blue-600 mr-1"
                                                fill="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"></path>
                                            </svg>
                                            {/* <p className="card-content">Verified</p> */}
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </Slider>
        </div>
    )
}

export default MeetSlider